function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M212.198 446.271V0H0V521.518L212.198 446.271Z",
  fill: "url(#paint0_radial_675:8269)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M212.198 446.629V0L635.778 11.701V465.203L212.198 446.629Z",
  fill: "url(#paint1_radial_675:8269)"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter0_f_675:8269)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M130.175 604.765L130.583 634.554L96.7134 614.15V584.361L130.175 604.765Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.557 618.231V587.625L130.175 604.765L130.583 634.554L159.557 618.231Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.557 587.625L182.001 600.276V629.657L159.557 618.231V587.625Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M209.75 612.518V583.545L182.001 600.684V629.657L209.75 612.518Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.736 552.123L269.328 523.966L188.53 570.894L209.342 586.401L269.736 552.123Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M61.211 531.311L124.285 566.714L96.7129 584.361L130.175 604.61L269.328 523.966L229.337 499.482L229.26 499.531L229.337 499.482L94.673 510.5L61.211 531.311ZM210.158 583.545L182.001 600.684L159.557 587.626L188.53 570.895L192.716 573.343L210.158 583.545Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M152.619 550.491L119.565 531.311L197.916 525.598L152.619 550.491Z",
  fill: "#BDC3CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M61.2111 553.755V531.311L124.462 566.406L105.691 579.056L61.2111 553.755Z",
  fill: "#BDC3CD"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M113.852 588.442L114.261 618.231L80.3904 597.827V568.038L113.852 588.442Z",
  fill: "url(#paint2_linear_675:8269)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M143.234 601.908V571.302L113.852 588.442L114.26 618.231L143.234 601.908Z",
  fill: "#BDC3CD"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M143.234 571.302L165.678 583.953V613.334L143.234 601.908V571.302Z",
  fill: "url(#paint3_linear_675:8269)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M193.427 596.195V567.222L165.678 584.361V613.334L193.427 596.195Z",
  fill: "#BDC3CD"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M253.413 535.8L253.005 507.643L172.207 554.571L193.019 570.078L253.413 535.8Z",
  fill: "#BDC3CD"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M80.3899 568.038L107.962 550.391L44.8881 514.988L78.3501 494.177L213.014 483.159L253.005 507.643L113.852 588.287L80.3899 568.038ZM193.835 567.222L165.678 584.361L143.234 571.302L172.207 554.571L176.393 557.02L193.835 567.222Z",
  fill: "url(#paint4_linear_675:8269)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M136.296 534.168L103.242 514.988L181.593 509.275L136.296 534.168Z",
  fill: "#BDC3CD"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M44.8881 537.432V514.988L108.139 550.083L89.368 562.733L44.8881 537.432Z",
  fill: "url(#paint5_linear_675:8269)"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 612.068,
  cy: 578.626,
  rx: 105.691,
  ry: 25.7086,
  transform: "rotate(-33 612.068 578.626)",
  fill: "url(#paint6_radial_675:8269)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M581.096 413.378L614.15 428.885L543.553 563.141L511.723 545.756L581.096 413.378Z",
  fill: "url(#paint7_linear_675:8269)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M637.818 490.912L653.733 499.89L637.818 509.683V490.912Z",
  fill: "#BDC3CD"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M511.724 545.186L543.962 562.325V587.625L511.724 569.67V545.186Z",
  fill: "#BDC3CD"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M543.962 562.733V587.625L603.948 554.163L604.764 590.074L637.818 571.711V534.168L653.325 526.006V500.298L637.818 509.275V412.562L613.742 429.293L543.962 562.733Z",
  fill: "url(#paint8_linear_675:8269)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M604.764 590.074L585.993 580.688V564.365L603.948 554.163L604.764 590.074Z",
  fill: "#BDC3CD"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M605.172 528.047L573.751 545.186L605.989 484.791L605.172 528.047Z",
  fill: "#BDC3CD"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M613.334 428.885L581.096 413.378L605.989 395.423L637.818 412.562L613.334 428.885Z",
  fill: "#F1F2F6"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 365.634,
  cy: 278.306,
  r: 124.054,
  fill: "url(#paint9_linear_675:8269)"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 365.634,
  cy: 278.306,
  r: 92.2245,
  fill: "url(#paint10_linear_675:8269)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M434.186 279.753C434.278 275.599 432.492 271.603 428.878 267.877C428.878 267.874 428.878 267.867 428.878 267.867C428.878 264.324 425.997 261.443 422.451 261.443C421.852 261.443 421.257 261.525 420.681 261.695C418.465 260.416 416.039 259.227 413.457 258.148C411.736 257.431 409.785 256.713 407.53 255.967C412.352 238.504 410.589 225.636 402.621 220.531C394.271 215.168 380.454 219.896 365.632 233.349C350.815 219.904 337.013 215.157 328.643 220.531C323.574 223.779 320.963 230.206 321.063 239.155C319.476 240.357 318.523 242.229 318.523 244.249C318.523 246.8 320.029 249.061 322.297 250.088C322.573 251.438 322.918 252.899 323.343 254.511C306.822 259.514 297.282 267.582 297.081 276.784C296.899 285.054 304.261 292.729 317.806 298.387C319.536 299.113 321.499 299.833 323.77 300.581C323.131 302.864 322.637 304.893 322.267 306.758C319.411 321.158 321.677 331.545 328.646 336.012C337.042 341.375 350.827 336.631 365.635 323.187C376.343 332.906 386.566 338.243 394.534 338.248C397.583 338.248 400.304 337.497 402.627 336.01C409.594 331.545 411.857 321.158 409.002 306.758C408.721 305.344 408.357 303.786 407.9 302.042C424.434 297.034 433.986 288.963 434.186 279.753ZM332.132 330.556C327.695 327.714 326.378 319.286 328.613 308.014C328.941 306.364 329.384 304.535 329.965 302.458C336.12 304.101 342.852 305.337 350.02 306.135C353.569 310.699 357.24 314.91 360.95 318.682C349 329.44 337.754 334.153 332.132 330.556ZM332.132 225.979C337.737 222.405 349 227.097 360.95 237.858C357.397 241.466 353.886 245.469 350.496 249.784C343.052 250.32 336.059 251.339 329.665 252.826C329.37 251.67 329.099 250.515 328.851 249.333C330.416 248.134 331.369 246.258 331.369 244.249C331.369 241.69 329.84 239.411 327.584 238.389C327.586 233.805 328.452 228.336 332.132 225.979ZM331.856 296.27C333.086 292.711 334.551 289.066 336.232 285.392C337.848 288.266 339.55 291.101 341.313 293.851C342.379 295.519 343.496 297.19 344.685 298.897C340.133 298.198 335.837 297.32 331.856 296.27ZM341.315 262.686C339.543 265.455 337.846 268.275 336.255 271.103C334.433 267.074 332.857 263.062 331.542 259.111C335.847 258.12 340.442 257.343 345.271 256.793C343.902 258.74 342.58 260.713 341.315 262.686ZM339.769 278.247C341.952 274.075 344.303 270.022 346.765 266.177C348.894 262.854 351.273 259.458 353.841 256.064C357.895 255.838 361.979 255.769 366.118 255.864C370.022 255.949 373.945 256.17 377.778 256.531C380.211 259.772 382.472 263.01 384.502 266.175C386.961 270.018 389.314 274.077 391.495 278.248C389.288 282.482 386.938 286.553 384.502 290.358C382.361 293.697 379.987 297.094 377.428 300.469C373.376 300.691 369.297 300.757 365.146 300.667C361.252 300.587 357.334 300.363 353.486 300.002C351.048 296.759 348.792 293.516 346.765 290.358C344.332 286.56 341.981 282.488 339.769 278.247ZM385.992 299.744C387.363 297.787 388.691 295.816 389.949 293.851C391.715 291.094 393.419 288.259 395.031 285.387C396.876 289.442 398.472 293.466 399.782 297.41C395.46 298.41 390.842 299.191 385.992 299.744ZM389.949 262.686C388.871 261.001 387.755 259.33 386.574 257.638C391.096 258.332 395.378 259.208 399.359 260.255C398.13 263.808 396.673 267.442 395.01 271.105C393.424 268.285 391.729 265.467 389.949 262.686ZM401.25 254.065C395.092 252.425 388.373 251.198 381.245 250.402C377.695 245.838 374.027 241.627 370.315 237.86C382.264 227.1 393.537 222.408 399.135 225.981C404.412 229.363 405.18 239.802 401.25 254.065ZM366.26 249.392C365.012 249.365 363.768 249.352 362.536 249.352C361.417 249.352 360.305 249.361 359.203 249.385C361.315 246.911 363.466 244.563 365.637 242.365C367.896 244.657 370.126 247.093 372.297 249.649C370.169 249.519 368.169 249.437 366.26 249.392ZM325.167 260.798C326.996 266.335 329.455 272.205 332.483 278.283C329.722 283.839 327.43 289.248 325.665 294.393C323.621 293.718 321.858 293.065 320.298 292.416C309.693 287.986 303.432 282.196 303.55 276.923C303.68 270.846 311.726 264.872 325.167 260.798ZM365.009 307.143C367.386 307.193 369.746 307.198 372.066 307.15C369.954 309.624 367.801 311.974 365.632 314.176C363.381 311.894 361.15 309.458 358.97 306.888C361.127 307.018 363.1 307.101 365.009 307.143ZM380.768 306.756C388.215 306.223 395.224 305.198 401.644 303.702C402.062 305.3 402.395 306.718 402.655 308.017C404.89 319.284 403.578 327.713 399.14 330.557C393.523 334.153 382.267 329.433 370.317 318.685C373.865 315.08 377.372 311.08 380.768 306.756ZM406.046 295.75C404.193 290.126 401.755 284.263 398.779 278.278C401.531 272.758 403.83 267.343 405.614 262.151C407.67 262.833 409.4 263.47 410.964 264.122C412.803 264.894 414.545 265.722 416.164 266.593C416.074 267.013 416.029 267.438 416.029 267.865C416.029 271.406 418.914 274.288 422.451 274.288C423.447 274.288 424.42 274.054 425.298 273.612C426.948 275.654 427.76 277.667 427.715 279.615C427.59 285.696 419.525 291.672 406.046 295.75Z",
  fill: "url(#paint11_radial_675:8269)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M365.632 266.271C359.019 266.271 353.638 271.655 353.638 278.268C353.638 284.884 359.019 290.265 365.632 290.265C372.248 290.265 377.629 284.884 377.629 278.268C377.629 271.655 372.248 266.271 365.632 266.271Z",
  fill: "url(#paint12_radial_675:8269)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M422.763 261.167C419.164 261.167 416.235 264.097 416.235 267.696C416.235 271.296 419.164 274.225 422.763 274.225C426.364 274.225 429.293 271.296 429.293 267.696C429.293 264.097 426.364 261.167 422.763 261.167Z",
  fill: "url(#paint13_radial_675:8269)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M324.826 238.315C321.226 238.315 318.297 241.245 318.297 244.844C318.297 248.444 321.226 251.373 324.826 251.373C328.426 251.373 331.355 248.444 331.355 244.844C331.355 241.245 328.426 238.315 324.826 238.315Z",
  fill: "url(#paint14_radial_675:8269)"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  filter: "url(#filter1_f_675:8269)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 312.584,
  cy: 286.467,
  rx: 63.6594,
  ry: 124.054,
  fill: "black"
}));

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 304.423,
  cy: 278.306,
  rx: 63.6594,
  ry: 124.054,
  fill: "#B3B2C4"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 299.526,
  cy: 278.306,
  rx: 58.7625,
  ry: 124.054,
  fill: "url(#paint15_linear_675:8269)"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 292.997,
  cy: 278.306,
  rx: 52.2334,
  ry: 124.054,
  fill: "#B3B2C4"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 287.284,
  cy: 278.306,
  rx: 46.5203,
  ry: 124.054,
  fill: "url(#paint16_radial_675:8269)"
});

var _ref32 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  filter: "url(#filter2_f_675:8269)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M299.025 293.864C298.318 301.505 296.909 308.161 295.099 313.237C293.767 316.974 292.371 319.42 291.228 320.775C291.13 320.891 291.04 320.994 290.956 321.084C290.873 320.994 290.782 320.891 290.684 320.775C289.542 319.42 288.145 316.974 286.813 313.237C285.509 309.58 284.413 305.102 283.638 300.027L294.413 289.252L299.025 293.864ZM299.466 286.672C299.505 285.398 299.526 284.105 299.526 282.795C299.526 270.517 297.738 259.754 295.099 252.352C294.956 251.949 294.811 251.561 294.667 251.188L297.987 279.032L292.625 279.642L288.815 247.698C288.158 248.945 287.478 250.488 286.813 252.352C284.174 259.754 282.387 270.517 282.387 282.795C282.387 286.412 282.542 289.897 282.828 293.204L291.413 284.619L294.629 287.835L297.629 284.835L299.466 286.672ZM290.259 321.693C290.258 321.692 290.275 321.682 290.307 321.668C290.275 321.688 290.259 321.695 290.259 321.693ZM291.605 321.668C291.638 321.682 291.654 321.692 291.654 321.693C291.654 321.695 291.637 321.688 291.605 321.668ZM291.654 243.896C291.654 243.898 291.638 243.908 291.605 243.921C291.637 243.901 291.654 243.894 291.654 243.896ZM290.307 243.921C290.275 243.908 290.258 243.898 290.259 243.896C290.259 243.894 290.275 243.901 290.307 243.921ZM307.687 282.795C307.687 308.712 300.196 329.723 290.956 329.723C281.716 329.723 274.225 308.712 274.225 282.795C274.225 256.877 281.716 235.866 290.956 235.866C300.196 235.866 307.687 256.877 307.687 282.795Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 295.445,
  cy: 283.611,
  rx: 4.08073,
  ry: 8.56954,
  fill: "black"
}));

var _ref33 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M290.864 285.702C290.157 293.344 288.748 300 286.938 305.076C285.606 308.813 284.209 311.258 283.067 312.614C282.969 312.73 282.878 312.832 282.795 312.922C282.711 312.832 282.621 312.73 282.523 312.614C281.38 311.258 279.984 308.813 278.652 305.076C277.348 301.419 276.252 296.941 275.476 291.865L286.252 281.09L290.864 285.702ZM291.304 278.511C291.344 277.237 291.364 275.944 291.364 274.633C291.364 262.355 289.577 251.593 286.938 244.191C286.794 243.788 286.65 243.4 286.505 243.027L289.826 270.87L284.463 271.481L280.654 239.537C279.997 240.783 279.316 242.326 278.652 244.191C276.013 251.593 274.225 262.355 274.225 274.633C274.225 278.25 274.38 281.736 274.667 285.043L283.252 276.458L286.467 279.674L289.467 276.674L291.304 278.511ZM282.097 313.532C282.097 313.53 282.113 313.52 282.146 313.507C282.113 313.526 282.097 313.533 282.097 313.532ZM283.444 313.507C283.476 313.52 283.492 313.53 283.492 313.532C283.492 313.533 283.476 313.526 283.444 313.507ZM283.492 235.735C283.492 235.736 283.476 235.746 283.444 235.76C283.476 235.74 283.492 235.733 283.492 235.735ZM282.146 235.76C282.113 235.746 282.097 235.736 282.097 235.735C282.097 235.733 282.113 235.74 282.146 235.76ZM299.526 274.633C299.526 300.551 292.035 321.562 282.795 321.562C273.554 321.562 266.064 300.551 266.064 274.633C266.064 248.715 273.554 227.705 282.795 227.705C292.035 227.705 299.526 248.715 299.526 274.633Z",
  fill: "url(#paint17_linear_675:8269)"
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 287.284,
  cy: 275.449,
  rx: 4.08073,
  ry: 8.56954,
  fill: "url(#paint18_linear_675:8269)"
});

var _ref35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_675:8269",
  x: 41.211,
  y: 479.482,
  width: 248.525,
  height: 175.072,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  result: "effect1_foregroundBlur_675:8269"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_675:8269",
  x: 238.925,
  y: 152.413,
  width: 147.319,
  height: 268.109,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur_675:8269"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_675:8269",
  x: 264.225,
  y: 225.866,
  width: 53.462,
  height: 113.857,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur_675:8269"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(203.816 307.266) rotate(118.089) scale(337.884 242.726)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDC3CD",
  stopOpacity: 0.59
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4E5EB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(228.929 274.087) rotate(35.563) scale(560.656 304.888)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDC3CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4E5EB",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_675:8269",
  x1: 97.3255,
  y1: 568.038,
  x2: 97.3255,
  y2: 618.231,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F1F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D9E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_675:8269",
  x1: 154.456,
  y1: 571.302,
  x2: 154.456,
  y2: 613.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F1F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D9E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_675:8269",
  x1: 148.946,
  y1: 483.159,
  x2: 148.946,
  y2: 588.287,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E3EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD0D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_675:8269",
  x1: 76.5137,
  y1: 514.988,
  x2: 76.5137,
  y2: 562.733,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F1F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D9E0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(612.068 578.626) rotate(90) scale(25.7086 105.691)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BDC3CD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BDC3CD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_675:8269",
  x1: 600.991,
  y1: 421.288,
  x2: 524.778,
  y2: 553.292,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F0F1F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8D9E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_675:8269",
  x1: 598.643,
  y1: 412.562,
  x2: 598.643,
  y2: 590.074,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4E3EA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCD0D7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_675:8269",
  x1: 365.634,
  y1: 154.252,
  x2: 336.252,
  y2: 392.566,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CBCDD6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#90909F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_675:8269",
  x1: 365.634,
  y1: 186.081,
  x2: 365.634,
  y2: 370.53,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4B5268"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#353C54"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(349.998 330.952) rotate(-76.5668) scale(67.3044 329.144)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(362.898 288.805) rotate(-78.2054) scale(13.3845 57.9621)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(421.275 273.43) rotate(-78.2041) scale(7.28437 31.5483)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint14_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(323.337 250.578) rotate(-78.2041) scale(7.28437 31.5483)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_675:8269",
  x1: 299.526,
  y1: 154.252,
  x2: 299.526,
  y2: 402.36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4B5268"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#353C54"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_675:8269",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(276.674 387.262) rotate(-85.5221) scale(135.895 228.93)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D7D8DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_675:8269",
  x1: 282.795,
  y1: 227.705,
  x2: 254.526,
  y2: 309.452,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CBCDD6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#90909F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_675:8269",
  x1: 287.284,
  y1: 266.88,
  x2: 287.284,
  y2: 284.019,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4B5268"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#353C54"
})));

function SvgPageNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 715,
    height: 658,
    viewBox: "0 0 715 658",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNote);
export default __webpack_public_path__ + "static/media/pageNote.b602bbd1.svg";
export { ForwardRef as ReactComponent };